module.exports = __webpack_public_path__ + "img/hubei.b6493aec.png";